export default __webpack_public_path__ + "static/air-whoosh-58e5b087b3e196f863428893b9ef40f6.mp3";